import LogService from 'lib/services/LogService';
import LocalStorage from 'lib/utils/LocalStorage';
import React from 'react';
import Constants from 'lib/Constants';
import Button from '../Button';
import './style.scss';

export default class ErrorBoundary extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            errorText: '',
            errorInfo: ''
        };
    }

    logError = async (message, error, info) => {
        // we try to pull user object from localstorage since the error might have
        // happened before one was established, but we still a reference...
        let user = this.props.auth ? this.props.auth.user : null;
        if (!user) {
            user = LocalStorage.get(Constants.CURRENT_USER);
        }

        // just get their user id
        if (user) {
            if (user._id) {
                user = user._id;
            }
        }

        await LogService.logError(message, error, info, user);
    }

    static getDerivedStateFromError(error) {
        return { errorText: error.message, hasError: true };
    }

    componentDidCatch = (error, errorInfo) => {
        errorInfo = errorInfo.componentStack || errorInfo;

        this.setState({
            hasError: true,
            errorText: error.message,
            errorInfo
        });

        console.log('client error', error, errorInfo)
        if (process.env.LOG_CLIENT_ERRORS == 'true') {
            this.logError(error.message, error, errorInfo);
        }
    }

    render = () => {
        if (this.state.hasError) {
            // You can render any custom fallback UI flex-col-fill
            return (
                <div className="error-boundary flex-col-fill flex-col-center-both center">
                    <div className="inner flex-col-center-both">
                        <h1 className="title">Something went wrong.</h1>
                        <div className="error-text">{this.state.errorText}</div>

                        { ['local', 'development'].includes(process.env.NODE_ENV) ?
                            <div className="stack-trace">
                                <h6 className="margin xs ns">Stack trace:</h6>
                                <textarea rows="32" defaultValue={this.state.errorInfo}></textarea>
                            </div>
                            :
                            <div className="msg">
                                The error has been forwarded to our developers.<br/>
                                Please refresh the page to continue, or click below.
                            </div>
                        }
                        <Button link="/" filled round color="blue" className="margin lg flex-col-fill">Go home</Button>
                    </div>
                </div>
            )
        }

        return this.props.children;
    }

}